export default "__VITE_ASSET__b6cc44e1__"